import { useEffect } from "react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import {
    activityWindow,
    currentPage,
    filtersValue,
    groups,
    hasSearched,
    isLoadingFilters,
    isLoadingList,
    loadError,
    pageSize,
    submittedFilters,
    totalCount
} from "../@signals"


export default function useSkuDuplicates() {
    const { showToast } = useAppToast()

    const fetchDuplicates = () => {
        isLoadingList.value = true
        loadError.value = false
        groups.value = []

        postSubmit(`${BACKEND_APIS.SKU_DUPLICATES}/search`, {
            ...submittedFilters.value,
            page: currentPage.value,
            pageSize: pageSize.value
        })
            .then(res => {
                if (res) {
                    groups.value = res.data || []
                    totalCount.value = res.total || 0
                    activityWindow.value = { activeSince: res.activeSince, includeInactive: !!res.includeInactive }
                }
                hasSearched.value = true
            })
            .catch(() => {
                loadError.value = true
                showToast.error('Error loading duplicates')
            })
            .finally(() => {
                isLoadingList.value = false
                isLoadingFilters.value = false
            })
    }

    // Trigger search when filters are submitted
    useEffect(() => {
        if (isLoadingFilters.value) {
            submittedFilters.value = filtersValue.value
            fetchDuplicates()
        }
    }, [isLoadingFilters.value])

    // Page changes keep the submitted filters
    useEffect(() => {
        if (submittedFilters.value && !isLoadingFilters.value) fetchDuplicates()
    }, [currentPage.value, pageSize.value])

    return { refetch: fetchDuplicates }
}
